import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import { Text, Icon } from '../..'

export class PromoBanner extends React.PureComponent {
  static propTypes = {
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(Element)
    ]),
    subtitle: PropTypes.string,
    id: PropTypes.string,
    className: PropTypes.string,
    showIcon: PropTypes.bool,
    isShowPromoBanner: PropTypes.bool,
    style: PropTypes.object,
    refProp: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({ current: PropTypes.instanceOf(Element) })
    ])
  }

  static defaultProps = {
    showIcon: false,
    isShowPromoBanner: false
  }

  render() {
    const { title, subtitle, showIcon, id, isShowPromoBanner, className, style, refProp } = this.props

    return (
      <div
        id={id}
        className={cn('ui-promo-banner', {
          'ui-no-banner': !isShowPromoBanner
        }, className)}
        style={style}
        ref={refProp}
      >
        <Text type={Text.Types.bodyBold}>{title}</Text>
        <span className='ui-promo-banner-subtitle'>
          {showIcon && <Icon type='error_outline'></Icon>}
          <Text>{subtitle}</Text>
        </span>
      </div>
    )
  }
}
